import axios from "axios";
import { useEffect, useState, useCallback } from "react";

const useAsync = (asyncFunction, dependencies = []) => {
  const [data, setData] = useState([] || {});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const execute = useCallback(async () => {
    setLoading(true);
    setError("");

    let unmounted = false;
    let source = axios.CancelToken.source();

    try {
      const res = await asyncFunction({ cancelToken: source.token });
      if (!unmounted) {
        setData(res);
        setError("");
      }
    } catch (err) {
      if (!unmounted) {
        if (axios.isCancel(err)) {
          setError(err.message);
          setData([]);
        } else {
          setError(err.message);
          setData([]);
        }
      }
    } finally {
      if (!unmounted) {
        setLoading(false);
      }
    }

    return () => {
      unmounted = true;
      source.cancel("Cancelled in cleanup");
    };
  }, [asyncFunction]);

  const refetch = useCallback(() => {
    return execute();
  }, [execute]);

  useEffect(() => {
    execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  return {
    data,
    error,
    loading,
    refetch,
  };
};

export default useAsync;
